import * as React from 'react';
import { Link, LinkProps } from './Link';

export function LinkWithoutUnderline(props: LinkProps) {
   return <Link {...props} _hover={{ textDecoration: 'none' }} />;
}
